import { PageExpenses } from "@components/modules/expenses/listing/PageExpenses";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Expenses`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.Expenses}>
      <PageExpenses />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/expenses/")({
  component: Page,
});
